import { render, staticRenderFns } from "./attrModules.vue?vue&type=template&id=663295cf&"
import script from "./attrModules.vue?vue&type=script&lang=js&"
export * from "./attrModules.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports